module.exports = __webpack_public_path__ + "img/ico5.7d1a754e.png";